export default __webpack_public_path__ + "static/media/Tw_btn.2f6c6c92.png";